module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABM0lEQVQ4T7WSPUsDQRCGn/eIET8qwc5eCdjYCVZ2EtHKzkJEFCwlCDEWJ+aw0cpKIa2lvyBtQEtr01horVbmlIzcbQwmF70DcWBhZ3fnmX1nRnzZvk2RYzZ2xSKw3r2LNkYduIrPPJpUde+eRla2Ah4N4KkTNAlE67u9AI+dgwJtFjhRwwEqtg2sEGg59n2boMV0T3ieB47kElTMgB0CXTrAgW0i1gi01Jd1sBsBxBZV1ZIA3zxCLhAjfdEhQ+zi6y3+wY8ATByyQZvxHkCEzVHD10cKIIOIVAnv7GGMJSTkOcNX+PsPXA1O0QDAKyXO1fpnCa6tRcRoLKGNMUwdX89dSak1CLmGTheE4VHiWHfZABmakKyBG+VVAhWzxCdHuWwzeNwCzUwAmAPmCXTjRvkP9gkaGpMRbATq0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/geren/nav_btn_order_sel.png
// module id = Ve3u
// module chunks = 1